'use client'

import { prepareForSlot } from '@mui/base'
import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'

import { type CachedGlossaryEntryDto } from '@redteclab/api/clients/bully'

import { Chip } from 'base-ui'

import { type LOCALE } from '../../../../i18n'
import { NextLink } from '../../../../next-link'
import { type CmsGlossaryDefinition } from '../../../model/glossary/cmsGlossary'
import { cmsGlossaryBuildDetailsUrl } from '../model/cmsGlossaryBuildDetailsUrl'

const LinkSlot = prepareForSlot(NextLink)

export const CmsGlossaryIndex: FC<
  Omit<ComponentProps<'ul'>, 'children'> & {
    currentLetter?: string
    entries?: CachedGlossaryEntryDto[] | null
    glossaryDefinition?: CmsGlossaryDefinition | null
    locale: LOCALE
  }
> = ({
  className,
  currentLetter,
  entries,
  glossaryDefinition,
  locale,
  ...props
}) => (
  <ul {...props} className={clsx('flex flex-wrap gap-x-2 gap-y-4', className)}>
    {glossaryDefinition
      ? entries
          ?.filter((item) => item.hasEntries)
          .map((item) => (
            <li key={item.name}>
              <Chip
                aria-current={item.name === currentLetter ? 'page' : undefined}
                href={cmsGlossaryBuildDetailsUrl({
                  glossaryDefinition,
                  letter: item.name,
                  locale,
                })}
                selected={item.name === currentLetter}
                size="medium"
                slots={{ root: LinkSlot }}
              >
                {item.name.toUpperCase()}
              </Chip>
            </li>
          ))
      : null}
  </ul>
)
